module.exports = __webpack_public_path__ + "static/img/bg-ar.aa441523.png";